import React from 'react'

import {
  StyledDesktopLogo,
  StyledLogoContainer,
  StyledMobileLogo,
} from './Logo.styled'
import RoutingEnum from '../../routes/appRoutes'
import { IconTypeEnum } from '../../theme/icons'
import IconButton from '../IconButton/IconButton'

const Logo = ({ light, isMobile }) => {
  const typeLogo = isMobile
    ? IconTypeEnum.logoHeaderMobile
    : IconTypeEnum.logoHeader
  return (
    <StyledLogoContainer>
      <IconButton
        target={light ? '_blank' : '_self'}
        type={typeLogo}
        to={RoutingEnum.home}
        width="auto"
        ariaLabel="constellium logo"
      >
        <StyledMobileLogo />
        <StyledDesktopLogo />
      </IconButton>
    </StyledLogoContainer>
  )
}

export default Logo
